import React from 'react'
import { IconInfoCircle } from '@tabler/icons-react'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

export const LabelWithHelp = ({ label, help }) => (
  <div className="label-style flex-align-center small-gap">
    {label}
    {help && (
      <InteractiveTooltip content={help} theme="light" narrow>
        <IconInfoCircle className="icon-svg copilot-prompt__help-icon" />
      </InteractiveTooltip>
    )}
  </div>
)
